export default __webpack_public_path__ + "static/media/airline.365278b4.svg";